import type { FromModel } from "@/__main__/data-model.mjs";
import { Union } from "@/__main__/data-model.mjs";

export const paymentProviderTypeModel = Union([
  "STRIPE",
  "BRAINTREE",
  "UNKNOWN",
]);

export type PaymentProviderType = FromModel<typeof paymentProviderTypeModel>;
